// Generated with util/create-component.js
import Typography from './Typography';

export default Typography;
